import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_SALP_PERSONAL_STORY_TOGGLE = createFcmDetails('starfish_salp_personal_story_toggle', {
	owner: 'starfish',
	context: 'Start a Local Petition - Personal Story Step',
	description:
		'Feature toggle to display the personal story step in the SAP flow after the AI Ask Choice step. This fcm is tied to an experiment `salpPersonalStoryToggle',
	mergeLogic: 'Needs combination of both country code and locale to be enabled',
	import: false,
});
